import type { TicketDraft } from './types';

type DraftField = 'title' | 'description' | 'outcome' | 'tags' | 'signature';

export function countCharacters(value: string): number {
  return [...value].length;
}

export function validateDraft(draft: TicketDraft): Partial<Record<DraftField, string>> {
  const errors: Partial<Record<DraftField, string>> = {};
  const title = draft.title.trim();
  const outcome = draft.outcome.trim();
  const signature = draft.signature.trim();

  if (!title) errors.title = '请填写标题';
  else if (countCharacters(title) > 40) errors.title = '标题最多 40 个字';

  if (countCharacters(draft.description) > 300) errors.description = '详细说明最多 300 个字';

  if (!outcome) errors.outcome = draft.type === 'reward' ? '请填写奖励内容' : '请填写惩罚内容';
  else if (countCharacters(outcome) > 160) errors.outcome = `${draft.type === 'reward' ? '奖励' : '惩罚'}内容最多 160 个字`;

  if (draft.tags.length > 3 || draft.tags.some((tag) => countCharacters(tag.trim()) > 10)) {
    errors.tags = '最多 3 个标签，每个最多 10 个字';
  }

  if (!signature) errors.signature = '请填写署名';

  return errors;
}
